function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "chevron-small-down",
  d: "M18.39,12.5a.845.845,0,0,1,1.189,0,.826.826,0,0,1,0,1.178l-4.752,4.657a.846.846,0,0,1-1.19,0L8.884,13.675a.828.828,0,0,1,0-1.178.845.845,0,0,1,1.189,0l4.16,3.82L18.39,12.5Z",
  transform: "translate(-8.638 -12.252)"
});
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.188,
    height: 6.324,
    viewBox: "0 0 11.188 6.324",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron_down.c3321170.svg";
export { ForwardRef as ReactComponent };